export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-fill, .btn-stroke, .btn-light");

		this.buttons.forEach( (button) => {

			const text = `<span class='label'>${button.innerHTML}</span>`;
			button.innerHTML = text;

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="6" height="13" viewBox="0 0 6 13" xmlns="http://www.w3.org/2000/svg">
<path d="M5.99882 6.46165C5.99095 6.30313 5.9304 6.15246 5.82763 6.0356L1.13221 0.718483C1.07387 0.652735 1.00371 0.599639 0.925735 0.562234C0.847764 0.524829 0.763508 0.503848 0.677778 0.500481C0.592048 0.497115 0.506523 0.511427 0.426087 0.542612C0.345651 0.573797 0.271879 0.621239 0.208983 0.682227C0.146088 0.743215 0.0953007 0.81656 0.0595219 0.898066C0.0237431 0.979571 0.00367341 1.06764 0.000458785 1.15726C-0.00275584 1.24687 0.0109476 1.33627 0.0407866 1.42034C0.0706256 1.50442 0.116016 1.58153 0.174365 1.64728L4.45813 6.5L0.174365 11.3527C0.116016 11.4185 0.0706256 11.4956 0.0407866 11.5796C0.0109476 11.6637 -0.00275584 11.7531 0.000458785 11.8427C0.00367341 11.9323 0.0237431 12.0204 0.0595219 12.1019C0.0953007 12.1834 0.146088 12.2568 0.208983 12.3178C0.271879 12.3788 0.345651 12.4262 0.426087 12.4574C0.506523 12.4886 0.592048 12.5029 0.677778 12.4995C0.763508 12.4962 0.847764 12.4752 0.925735 12.4378C1.00371 12.4004 1.07387 12.3473 1.13221 12.2815L5.82763 6.96439C5.88704 6.89693 5.93282 6.81764 5.96224 6.73126C5.99165 6.64488 6.00409 6.55317 5.99882 6.46165Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-download') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-gallery') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

	}

}
